export default __webpack_public_path__ + "3824ba7ab7fe18bf4d75733ed8740faf.svg";